// Точка входа веб-клиента.
//
// Стили подключаются из `design/` импортом, а не копией: единственный источник компонентов и токенов —
// у Дизайна, а относительные пути внутри `tokens.css` (шрифты) при этом разрешаются сами.

import "../../design/tokens/tokens.css";
import "../../design/components/components.css";
import "./app.css";

import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
import { router } from "./router.ts";

createApp(App).use(createPinia()).use(router).mount("#app");
